/**
 * Destination-scoped campaign badge (pinned_hotels custom badge_text).
 * SSOT: compare 3-letter LDS/IATA-style codes only — no country/name matching.
 */

export function normalizeDestinationCode(value) {
  if (value == null) return null;
  const s = String(value).trim();
  if (!s) return null;
  return s.toUpperCase();
}

/**
 * Best-effort 3-letter destination code from a search / package / composite hotel row.
 */
export function resolveResultDestinationCode(result) {
  if (!result || typeof result !== "object") return null;
  const raw =
    result.hotel?.hotelCity ??
    result.fullDeal?.hotel?.hotelCity ??
    result.hotelCity ??
    result.City ??
    result.city ??
    result.hotel_meta?.City ??
    result._compositeRaw?.hotel_meta?.City ??
    null;
  const n = normalizeDestinationCode(raw);
  if (n && /^[A-Z]{3}$/.test(n)) return n;
  return null;
}

/**
 * שורת חבילת LDS מ־PackageObject (`fullDeal` כשורש עם `hotel.hotelCity`).
 */
export function resolvePackageResultDestinationCode(packageDeal) {
  if (!packageDeal || typeof packageDeal !== "object") return null;
  return resolveResultDestinationCode(packageDeal);
}

export function shouldShowDestinationCampaign(campaign, result) {
  const want = normalizeDestinationCode(campaign?.destinationCode);
  if (!want) return false;
  const got = resolveResultDestinationCode(result);
  return Boolean(got && got === want);
}

/**
 * @param {object} result — hotel / composite VM row (must carry pinnedCampaignDestinationCode when set by API)
 */
export function shouldShowHotelsRiverPinnedImageBadge(result) {
  if (!result || typeof result !== "object") return false;
  if (result.isCampaignHotel === true) return true;
  const pinned = result.isPinnedByHotelsRiver === true || result.isPinned === true;
  if (!pinned) return false;
  const campaignDest = normalizeDestinationCode(result.pinnedCampaignDestinationCode);
  if (!campaignDest) return true;

  const resDest = resolveResultDestinationCode(result);
  return Boolean(resDest && resDest === campaignDest);
}
